import { useState } from "react";
import { useAuth, useLoad } from "../lib/api.jsx";
import { Wait, Tbl, Pager, Filters, csv } from "../lib/ui.jsx";

export default function UserLogins() {
  const { act } = useAuth();
  const [f, setF] = useState({ src: "new", search: "", from: "", to: "", open: "", page: 1 });
  const [d, reload] = useLoad("log_users", f);

  return (
    <>
      <h1>User logins</h1>
      <Filters f={f} setF={setF}>
        <select value={f.src} onChange={(e) => setF({ ...f, src: e.target.value, page: 1 })}>
          <option value="new">Session log</option><option value="auth">Auth log</option>
        </select>
        {f.src === "new" && (
          <label className="chk">
            <input type="checkbox" checked={f.open === "1"} onChange={(e) => setF({ ...f, open: e.target.checked ? "1" : "", page: 1 })} />
            Open sessions only
          </label>
        )}
        <button className="btn g" onClick={() => d?.rows && csv("logins", d.rows)}>Export page</button>
      </Filters>
      <Wait d={d}>
        {d && !d.error && (
          <>
            <Tbl rows={d.rows} empty="No login records match." cols={[
              ["User", (r) => r.Name || r.user_id], ["IP", (r) => r.ip], ["State", (r) => r.state],
              ["Signed in", (r) => r.in_time],
              ["Signed out", (r) => r.out_time || (f.src === "new" ? <span className="tag wait">open</span> : "-")],
              ["", (r) => f.src === "new" && !r.out_time && (
                <button className="btn d s" onClick={() => confirm("End this session record?") && act("session_end", { id: r.id }, "Session ended.").then(reload)}>End session</button>
              )],
            ]} />
            <Pager f={f} setF={setF} d={d} />
          </>
        )}
      </Wait>
    </>
  );
}
